import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { IconRegistryUtilityClass } from './icon-registry-utility-class/icon-registry.utils';

export function iconProviderInitializer(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const iconRegistry = inject(IconRegistryUtilityClass);
    return iconRegistry.registerIcons();
  });
}
